import { ProductLine } from '@adc/ui-core'
import configment from '@adc/configment'
import canUseDom from '../../../util/canUseDom'

export const AUCTION_RESIDENTIAL = 'auction_residential'
export const USER_LOGIN = 'user_login'
export const USER_SIGN_UP = 'user_create_account'
export const CALENDAR = 'calendar'

const DEFAULT_ORIGIN = 'https://www.auction.com'

/**
 * Take based on current origin (which may be smartsale) return the auction.com equivalent
 * Must be re-ran in the browser to get it right
 */
const getAuctionEquivalentOrigin = () => {
  if (!canUseDom()) {
    return DEFAULT_ORIGIN
  }
  const origin = window?.location?.origin || ''

  if (origin.includes('.smartsale.com')) {
    return origin.replace('.smartsale.com', '.auction.com')
  }

  return origin || DEFAULT_ORIGIN
}

const calendar = {
  className: 'calendar',
  elmId: 'h_calendar',
  title: 'Calendar',
  url: '/calendar ',
}

const newCalendar = {
  className: 'calendar',
  elmId: 'h_event_calendar',
  title: 'Event Calendar',
  url: '/calendar ',
}

const help = {
  className: 'help',
  elmId: 'h_help_center',
  title: 'Help',
  url: '/lp/learn-more/',
}

const helpCenter = {
  className: 'help',
  elmId: 'h_help_center',
  title: 'Help Center',
  url: '/lp/learn-more/',
}

const buyingForclosure = {
  className: 'help',
  elmId: 'h_buying_foreclosure',
  title: 'Buying a Foreclosure',
  url: '/lp/learn-more/foreclosure/',
}

const buyingBankOwned = {
  className: 'help',
  elmId: 'h_buying_bank_owned',
  title: 'Buying a Bank Owned',
  url: '/lp/learn-more/bank-owned/',
}

const blog = {
  className: 'help',
  elmId: 'h_blog',
  title: 'Blog',
  url: '/blog/',
}

const glossary = {
  className: 'help',
  elmId: 'h_glossary',
  title: 'Glossary',
  url: '/lp/learn-more/glossary/',
}

const buyAll = {
  className: 'buy-all',
  elmId: `h_${AUCTION_RESIDENTIAL}`,
  title: 'All Asset Types',
  url: '/residential',
}

const newBuyAll = {
  className: 'buy-all',
  elmId: `h_all`,
  title: 'All',
  url: '/residential',
}

export const buyGeneral = {
  className: ['all', 'mobile-division'],
  elmId: `h_${AUCTION_RESIDENTIAL}`,
  title: 'Buy',
  url: '/residential',
}

export const getSellLinkData = (
  theme = {
    productLine: ProductLine.AuctionCom,
  },
  featureFlags = {}
) => {
  const isSellLinkEnabled =
    featureFlags && featureFlags['fe.resi.sell-link-enabled']
  return {
    className: 'sell',
    elmId: `h_sell`,
    title: 'Sell',
    // eslint-disable-next-line no-nested-ternary
    url: !isSellLinkEnabled
      ? '/lp/sell-your-property/'
      : theme.productLine === ProductLine.AuctionCom
      ? `/apps/api/session-handoff?redirect-to=${encodeURIComponent(
          configment.get('SMARTSALE_HOST') + '/sell'
        )}`
      : '/sell-your-property',
  }
}

const bankOwned = {
  className: 'bank-owned',
  elmId: 'h_residential_bank_owned_newly_foreclosed',
  title: 'REO Bank Owned',
  url: '/residential/bank-owned,newly-foreclosed_at',
}

const newBankOwned = {
  className: 'bank-owned',
  elmId: 'h_bank_owned',
  title: 'Bank Owned',
  url: '/residential/bank-owned,newly-foreclosed_at',
}

const foreclosures = {
  className: 'foreclosure-sales',
  elmId: 'h_foreclosure_sales',
  title: 'Foreclosure Homes',
  url: '/residential/foreclosures_at',
}

const newForeclosures = {
  className: 'foreclosure-sales',
  elmId: 'h_foreclosure',
  title: 'Foreclosure',
  url: '/residential/foreclosures_at',
}

const shortSale = {
  className: 'short-sales',
  elmId: 'h_short_sales',
  title: 'Short Sales',
  url: '/residential/active_lt/distance,resi_sort_v2_st/y_global/short-sales_at',
}

const privateSeller = {
  className: 'private-seller',
  elmId: 'h_private_seller',
  title: 'Private Seller',
  url: '/residential/active_lt/distance,resi_sort_v2_st/y_global/private-seller_at',
}

// only applies to smartsale because auctioncom uses a full menu for this...
export const getSmartSaleBuyLinkData = () => ({
  ...privateSeller,
  title: 'Buy',
  url:
    getAuctionEquivalentOrigin() +
    '/residential/active_lt/distance,resi_sort_v2_st/y_global/private-seller_at',
})

export const aboutUs = {
  className: 'header-about-us',
  elmId: 'h_about_us',
  title: 'About Us',
  url: `/lp/about-us/`,
}

const BASE_DASHBOARD_PATH = '/dashboard'
const bidding = {
  className: 'bidding',
  elmId: 'h_bidding',
  title: 'Bidding',
  url: `${BASE_DASHBOARD_PATH}/bidding/`,
}

const offers = {
  className: 'offers',
  elmId: 'h_offers',
  title: 'Offers',
  url: `${BASE_DASHBOARD_PATH}/offers/`,
}

const savedAssets = {
  className: 'header-saved-assets',
  elmId: 'h_saved_assets',
  title: 'Saved Assets',
  url: `${BASE_DASHBOARD_PATH}/saved-properties/`,
}

const buyersDashboard = {
  className: 'header-buyer-dashboard-assets',
  elmId: 'h_buyer_dashboard_assets',
  title: 'Buyer Dashboard',
  url: `${BASE_DASHBOARD_PATH}/saved-properties/`,
}

const savedSearches = {
  className: 'header-saved-searches',
  elmId: 'h_saved_searches',
  title: 'Saved Searches',
  url: `${BASE_DASHBOARD_PATH}/saved-searches/`,
}

const sellerDashboard = {
  className: 'seller-profile',
  elmId: 'h_seller_dash',
  title: 'My Listings',
  url: `${BASE_DASHBOARD_PATH}/seller/`,
}

const myListings = {
  className: 'header-my-listings',
  elmId: 'h_my_listings',
  title: 'My Listings',
  url: `${BASE_DASHBOARD_PATH}/seller/`,
}

const accountInfo = {
  className: 'header-profile',
  elmId: 'h_account_info',
  title: 'Account Information',
  url: `${BASE_DASHBOARD_PATH}/account-info/`,
}

const preferenceCenter = {
  className: 'header-notification',
  elmId: 'h_notification',
  title: 'Notification Settings',
  url: `${BASE_DASHBOARD_PATH}/preference-center/`,
}

const purchaseProfiles = {
  className: 'header-purchase-profiles',
  elmId: 'h_purchase_profiles',
  title: 'Purchase Profiles',
  url: `${BASE_DASHBOARD_PATH}/purchase-profiles/`,
}

const postAuction = {
  className: 'header-post-auction',
  elmId: 'h_post_auction',
  title: 'Post Auction',
  url: `${BASE_DASHBOARD_PATH}/post-auction/`,
}

const userPreferences = {
  className: 'header-user-preferences',
  elmId: 'h_user_preferences',
  title: 'Preferences',
  url: `${BASE_DASHBOARD_PATH}/preferences/`,
}

const wallet = {
  className: 'header-wallet',
  elmId: 'h_wallet',
  title: 'Wallet',
  url: `${BASE_DASHBOARD_PATH}/wallet/`,
}

const logIn = {
  className: 'log-in',
  elmId: `h_${USER_LOGIN}`,
  title: 'Log In',
}

const logOut = {
  className: ['log-out', 'mobile-division'],
  elmId: 'h_user_logout',
  title: 'Log Out',
}

const signUp = {
  className: 'sign-up',
  elmId: `h_${USER_SIGN_UP}`,
  title: 'Sign Up',
}

export const generalRoutes = {
  calendar,
  help,
  helpCenter,
  logIn,
  logOut,
  signUp,
}

export const buyRoutes = {
  buyAll,
  bankOwned,
  foreclosures,
  shortSale,
}

export const newBuyRoutes = {
  newBuyAll,
  newForeclosures,
  newBankOwned,
  shortSale,
  privateSeller,
  newCalendar,
}

export const learnRoutes = {
  helpCenter,
  buyingForclosure,
  buyingBankOwned,
  blog,
  glossary,
}

export const loggedInRoutes = {
  bidding,
  offers,
  savedAssets,
  postAuction,
  savedSearches,
  sellerDashboard,
  myListings,
  buyersDashboard,
  accountInfo,
  preferenceCenter,
  purchaseProfiles,
  userPreferences,
  wallet,
}
